import { PATHS } from 'routes'

import { isTownsAppUrlString } from './isTownsAppUrl'

// Regex to match /bot/{appAddress} - bot addresses are only Ethereum addresses (0x[0-9a-f]{40})
// Start anchor ensures we only match /bot/ paths, not /developer/bot/ or other sub-paths
const botIdRegex = new RegExp(`^/${PATHS.BOT}/(0x[0-9a-f]{40})(?:/|$)`, 'i')

export const getBotParamsFromUrl = (url: string | undefined) => {
    if (typeof url !== 'string' || !isTownsAppUrlString(url)) {
        return undefined
    }
    try {
        const parsedUrl = new URL(url)
        const pathname = parsedUrl.pathname
        const parsed = pathname.match(botIdRegex)
        const appAddress = parsed?.[1]
        return appAddress ? { appAddress, botPath: pathname } : undefined
    } catch (e) {
        return undefined
    }
}
